import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CategoryGetForDropDownSlice } from "../../../../redux/features/CategorySlice";
import { onImageHandlerOneByOne } from "../../../../common/Image upload on bucket/UploadImageOnBucket";
import { CreateKnowledgeInsightSlice } from "../../../../redux/features/Knowledge insight by Admin/KnowledgeInsightByAdminSlice";
import axios from "axios";
import { IoMdClose } from "react-icons/io";
import Skeleton from "react-loading-skeleton";
import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";

const PublishedNewInsigth = () => {
  
  const [iState, setUpdate] = useState({
    title: "",
    description: "",
    images: [],
  });

  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState({
    imageUpload: false,
  });
  const fileInputRef = useRef(null);

  const navigate = useNavigate();
  
  const [imageForResize,setImageForResize] = useState([]);

  const [HoldData,setHoldData] = useState([]);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdate((prev) => ({ ...prev, [name]: value }));
  };

  function checkDimensions(file) { 
    return new Promise((resolve) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
  
      img.onload = function () {
        const isValid = img.width === 300 && img.height === 800;
        URL.revokeObjectURL(objectUrl); // Clean up
   
        if (!isValid) {
          toast.error("Please upload image of size 300 x 800 only");
        }
        resolve({ file, isValid });
      };
  
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        toast.error("Failed to load image for validation");
        resolve({ file, isValid: false }); // fail safe
      };
  
      img.src = objectUrl;
    });
  }

  const uploadOnBucket=async(allFiles)=>{
        try {
      setLoading((prev) => ({ ...prev, imageUpload: true }));

      let res = allFiles?.map((res) => onImageHandlerOneByOne(res));
      setLoading((prev) => ({ ...prev, imageUploadPenidng: res }));
      let uploadedImages = await axios.all(res);
      setLoading((prev) => ({ ...prev, imageUpload: false }));
      setUpdate((prev) => ({
        ...prev,
        images: [...prev["images"], ...uploadedImages],
      }));
      setHoldData([])
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (err) {
      console.log(err);
    }


  }
  
  const hanldeImage = async ({ e }) => {
    const { name, files } = e.target;
    
    let allFiles = Object.values(files);

    const checkResults = await Promise.all(
      allFiles.map((file)=>checkDimensions(file))
    );

    const validFiles = checkResults
      .filter((result) => result.isValid)
      .map((result) => result.file);

    if (validFiles.length > 0) {
      setHoldData((prev) => [...prev, ...validFiles]);
    } else {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  useEffect(()=>{
   uploadOnBucket(HoldData);
  },[HoldData])

  const handleSubmit = () => {
    console.log(iState);

    if (
         Object.entries(iState).some(([key, value]) => {
           if (
             [undefined, null, ""].includes(value) ||
             String(value)?.trim()?.length === 0
           ) {
             toast.error(`Please fill this field ${key}`);
             return true;
           }
         })
       ) {
         return;
       }

    dispatch(CreateKnowledgeInsightSlice(iState)).then((res) => {
      if (res?.payload?.customStatus === 201) {
        navigate(-1);
      }
    });
  };

  const hanldeRemoveImage = (index) => {
    const temp = iState?.images?.filter((item, i) => index !== i);
    setUpdate((prev) => ({ ...prev, images: [...temp] }));
  };

  return (
    <>
      <div className="TitleBox">
        <h4 className="Title">Content Management</h4>
        <Link className="TitleLink" onClick={() => navigate(-1)}>
          <i className="fa fa-arrow-left" /> Back
        </Link>
      </div>

      <div className="Small-Wrapper">
        <div className="CommonForm">
          <h4>ADD QuixSense</h4>
          <div
            className="row"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "20px",
                }}
              >
                <div className="col-sm-8">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>News title</label>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          value={iState?.title}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter News title..."
                        />
                      </div>
                    </div>

                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>News Description</label>
                        <textarea
                          type="text"
                          className="form-control"
                          name="description"
                          value={iState?.description}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter News ..."
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <label>Upload Images </label>
                    <div className="UploadBox">
                      <div className="Upload">
                        <>
                          <i className="fa fa-upload" /> <span>Upload </span>
                          <input
                            type="file"
                            name="images"
                            multiple
                            ref={fileInputRef}
                            onChange={(e) => hanldeImage({ e })}
                          />
                        </>
                      </div>
                      </div>
                      <div className="text-danger mt-2" style={{ fontSize: "12px", fontWeight: "600" }}>
                        * Note: Please upload images with exactly 300x800 dimensions.
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {Array.isArray(iState?.images) &&
            iState?.images?.map((item, index) => {
              return (
                <div
                  style={{
                    position: "relative",
                    height: "200px",
                    width: "200px",
                    border: "4px solid gray",
                    marginRight: "10px",
                  }}
                >
                  <img src={item} alt="" className="w-100 h-100" srcset="" />
                  <IoMdClose
                    onClick={() => hanldeRemoveImage(index)}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "-12px",
                      right: "-15px",
                      border: "3px solid gray",
                      color: "white",
                      backgroundColor: "gray",
                      borderRadius: "15px",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </div>
              );
            })}
          {loading?.imageUpload &&
            loading?.imageUploadPenidng?.map((item) => {
              return (
                <>
                 <div style={{
                     height: "200px",
                     width: "200px",
                     marginRight: "10px",
                 }}>
                  <Skeleton width={"100%"} height={"100%"} />{" "}
                  </div>
                </>
              );
            })}
        </div>
      </div>
      <button class="Button mt-4" onClick={handleSubmit}>
        Create
      </button>
    </>
  );
};

export default PublishedNewInsigth;

function MyVerticallyCenteredModal(props) {
  return ( 
   <>
    {/* <Modal
      {...props} 
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}    >
     
      <Modal.Body>
      
        <div className="flex ">
          <div style={{position:'relative',backgroundColor:'gray'}} onClick={()=>props.setModalShow((prev)=>!prev)}>
          <IoMdClose style={{backgroundColor:'gray',padding:'2px',borderRadius:'20px',color:'white',height:'25px',width:'25px',position:'absolute',right:'-15px',top:'-10px',cursor:'pointer'}}/>
          </div>
 {
      props.imageForBucket?.map((item)=>{
        return(
            <img src={item?.src} alt=""
            name="xyz"
            style={{
                width: "250px",
                height: "200px",
                margin: "10px",
                border:item?.style
              }}/>
        )
        })
     }       
     </div>
      </Modal.Body>
      <Modal.Footer>
          <Button variant="secondary" onClick={()=>{
            props.setModalShow(false)
          }}>
            Save
          </Button>
        </Modal.Footer>
    </Modal> */}
    </>
  );
}
